import { defineMessages } from 'react-intl'

const scope = `procurify.components.PunchOutStatusLabel`

export default defineMessages({
  orderFailedText: {
    id: `${scope}.orderFailedText`,
    defaultMessage: 'Order failed',
  },
})
